import {
  ImageScaleView,
  ImageScaleViewOpts,
  View,
  animate,
} from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { Match2Reward } from 'src/replicant/match2/rewards/match2-rewards.ruleset';
import { getRewardName } from '../rewards/match2-rewards.utils';
import { Match2RewardItem } from './Match2RewardItem';

export class RewardCard extends ImageScaleView {
  private content: View;

  constructor(opts: ImageScaleViewOpts & { reward: Match2Reward }) {
    super({
      image: 'assets/ui/match2/chest/card_back.png',
      width: 189,
      height: 230,
      centerAnchor: true,
      ...opts,
    });

    const content = new View({
      superview: this,
      width: this.style.width,
      height: this.style.height,
      visible: false,
    });
    this.content = content;

    new LangBitmapFontTextView({
      superview: content,
      localeText: () => getRewardName(opts.reward)!,
      width: content.style.width * 0.85,
      height: 60,
      align: 'center',
      verticalAlign: 'center',
      size: 25,
      color: '#BF8147',
      font: 'Body',
      x: content.style.width * 0.5,
      y: 25,
      centerOnOrigin: true,
    });

    const rewardImage = new Match2RewardItem({
      superview: content,
      size: 100,
      x: content.style.width * 0.5,
      y: content.style.height * 0.5,
      centerOnOrigin: true,
    });

    rewardImage.setReward(opts.reward);
  }

  public async turn() {
    await animate(this)
      .then({ scaleX: 0 }, 200, animate.easeIn)
      .then(() => {
        this.updateOpts({
          image: 'assets/ui/match2/chest/card_front.png',
        });
        this.content.show();
      })
      .then({ scaleX: 1 }, 200, animate.easeOut)
      .toPromise();
  }
}
